import { createSlice } from '@reduxjs/toolkit';
import { getCakeEditLogsByOrderId, CakeEditLog } from './api';

interface CakeEditLogsState {
  logs: CakeEditLog[];
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: string | null;
}

const initialState: CakeEditLogsState = {
  logs: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  error: null,
};

const cakeEditLogsSlice = createSlice({
  name: 'cakeEditLogs',
  initialState,
  reducers: {
    clearLogs: (state) => {
      state.logs = [];
      state.isError = false;
      state.isSuccess = false;
      state.error = null;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCakeEditLogsByOrderId.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.error = null;
      })
      .addCase(getCakeEditLogsByOrderId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.logs = action.payload.data || [];
        state.error = null;
      })
      .addCase(getCakeEditLogsByOrderId.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.logs = [];
        state.error = action.payload as string;
      });
  },
});

export const { clearLogs, reset } = cakeEditLogsSlice.actions;
export { getCakeEditLogsByOrderId } from './api';
export default cakeEditLogsSlice.reducer;
